<template>
    <div>
        <!-- BRAND GLOBAL DATA -->
          <div class="vx-row w-full mt-3" v-if="brandsLength > 0">
            <vx-card>
              <div class="vx-row w-full" v-if="brandsLength > 0">
                <div class="vx-col pt-3">
                  <h4>{{ "Keywords Marques VS Génériques de " + societyName }}
                    <span v-if="$acl.check('accountmanager')" @click="showBrandsPopup" style="width: 37px;" class="hvr-underline hvr-underline-out">
                      (Editer les marques)
                    </span></h4>
                </div>

              </div>
              <div class="vx-row mt-4" v-if="brandDataTotal">
                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 vs-con-loading__container" id="brand-rc-impressions" ref="brand-rc-impressions">
                  <report-card
                    tooltiptext="Nombre d’impressions sur Google provenant des requêtes marques."
                    title="Impressions"
                    :statistics="brandDataTotal.impressions == 0 ? 0 : formatThousandNumb(brandDataTotal.impressions)"
                    icon="icon-eye"
                    :color="'grey'"
                    :value="getValueInPercent(brandDataTotal.impressions, globalSiteDataKeywords.impressions)"
                    valtext="% du total"
                    :nosign="true"
                  />

                </div>

                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 vs-con-loading__container" id="brand-rc-clicks" ref="brand-rc-clicks">
                  <report-card
                    tooltiptext="Nombre de clics sur Google provenant des requêtes marques."
                    title="Clics"
                    :statistics="brandDataTotal.clicks == 0 ? 0 : formatThousandNumb(brandDataTotal.clicks)"
                    icon="icon-check"
                    :color="'grey'"
                    :value="getValueInPercent(brandDataTotal.clicks, globalSiteDataKeywords.clicks)"
                    valtext="% du total"
                    :nosign="true"
                  />

                </div>

                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 vs-con-loading__container" id="brand-rc-average-position" ref="brand-rc-average-position">
                  <report-card
                    tooltiptext="Position moyenne sur Google des mots-clés marques."
                    title="Position moyenne"
                    :statistics="formatValue(brandDataTotal.position, 0)"
                    icon="icon-activity"
                    :color="'grey'"
                    :value="'vs ' + formatValue(genericPosition, 0)"
                    valtext="(générique)"
                    :nosign="true"
                  />

                </div>

                <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 vs-con-loading__container" id="brand-rc-ctr" ref="brand-rc-ctr">
                  <report-card
                    tooltiptext="Ratio du nombre de clics / nombre d’impressions."
                    title="CTR"
                    :statistics="formatValue((brandDataTotal.ctr), 2) + ' %'"
                    icon="icon-percent"
                    :color="'grey'"
                    :value="'vs ' + formatValue((genericCTR), 2) + ' %'"
                    valtext="(générique)"
                    :nosign="true"
                  />
                </div>
              </div>
              <vx-card>
                <div class="vx-row mb-2">
                    <div class="vx-col">
                      <h4>Volumes des Impressions et des Clics des requêtes Marques sur Google</h4>
                    </div>
                  </div>
                <div class="vx-row w-full" v-if="stackedColumnChartOptionBrandTraffic && stackedColumnChartOptionBrandTraffic.chartOptions && stackedColumnChartOptionBrandTraffic.series">
                  <div class="vx-col w-full vs-con-loading__container" id="brand-stacked-traffic" ref="brand-stacked-traffic">
                      <apexchart
                        v-if="stackedColumnChartOptionBrandTraffic && stackedColumnChartOptionBrandTraffic.chartOptions && stackedColumnChartOptionBrandTraffic.series"
                        ref="monthlyBrandTrafficChart"
                        type="line"
                        height="350"
                        :options="stackedColumnChartOptionBrandTraffic.chartOptions"
                        :series="stackedColumnChartOptionBrandTraffic.series"
                      ></apexchart>
                  </div>
                </div>
              </vx-card>
              <!-- Bar CHART -->
              <div class="flex mt-4 vx-row" v-if="pageRankDataLength > 0">
                <!-- COLUMN CHART IMPRESSION -->
                <div class="vx-col">
                  <div class="vs-con-loading__container" id="brand-imp-comparison" ref="brand-imp-comparison">
                    <DuoBarChart
                      style="min-width: 400px; max-width: 1000px;"
                      v-if="impComparisonChartOptions"
                      :chartParams="impComparisonChartOptions"
                      :isPercent="false"
                    />
                  </div>
                  <vx-card class="mt-3 vs-con-loading__container" id="brand-listing-keywords" ref="brand-listing-keywords">
                    <div class="vx-row">
                      <div class="vx-col">
                        <h4>Listing des keywords marques</h4>
                      </div>
                    </div>
                    <div class="vx-row mt-1">
                      <div class="vx-col pt-2">
                        <span>Nombre de lignes affichées : </span>
                      </div>
                      <div class="vx-col">
                        <vs-select
                          autocomplete
                          v-model="brandKeywordsListingMaxRow"
                          class="select-large pb-4"
                        >
                          <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item"
                            v-for="(item, index) in pageNumberOptions"
                            class="w-full"
                          />
                        </vs-select>
                      </div>
                    </div>
                    <vs-table stripe hoverFlat auto-resize pagination :max-items="brandKeywordsListingMaxRow" v-if="brandKeywordsListing && brandKeywordsListing.length > 0" noDataText="" :data="brandKeywordsListing">
                      <template slot="thead">
                        <vs-th class="text-center" sort-key="keyword">Keyword</vs-th>
                        <vs-th sort-key="impressions"><vs-spacer/>Impressions</vs-th>
                        <vs-th sort-key="clicks"><vs-spacer/>Clics</vs-th>
                        <vs-th sort-key="ctr"><vs-spacer/>CTR</vs-th>
                        <vs-th sort-key="position"><vs-spacer/>Position</vs-th>
                      </template>

                      <template slot-scope="{data}">
                        <vs-tr :key="index" v-for="(row, index) of data">
                          <vs-td>
                            <strong>{{ row.keyword }}</strong>
                          </vs-td>
                          <vs-td class="txt_align_right">
                            {{ formatThousandNumb(row.impressions) }}
                          </vs-td>
                          <vs-td class="txt_align_right">
                            {{ formatThousandNumb(row.clicks) }}
                          </vs-td>
                          <vs-td class="txt_align_right">
                            {{ row.ctr.toFixed(2) + '%' }}
                          </vs-td>
                          <vs-td class="txt_align_right">
                            {{ row.counter > 0 ? Math.round(row.position / row.counter) : 0 }}
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </vx-card>
                </div>
                <div class="vx-col w-auto mt-4">
                  <!-- BAR CHART V1 -->
                  <vx-card v-if="pageRankDataLength > 0" class="w-full vs-con-loading__container" id="brand-page-clicks" ref="brand-page-clicks">
                    <div class="vx-row">
                      <div class="vx-col">
                        <h4>Clics par page : Requêtes Marques Organiques</h4>
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col pt-2">
                        <span>Nombre de lignes affichées : </span>
                      </div>
                      <div class="vx-col">
                        <vs-select
                          autocomplete
                          v-model="pagesRankDataNumberShown"
                          class="select-large pb-4"
                        >
                          <vs-select-item
                            :key="index"
                            :value="item"
                            :text="item"
                            v-for="(item, index) in pageNumberOptions"
                            class="w-full"
                          />
                        </vs-select>
                      </div>
                      <div class="vx-col pt-2">
                        <span>Recherche par keyword : </span>
                      </div>
                      <div class="vx-col">
                        <vs-input class="inputx" placeholder="Keyword" v-model="pageSearchInput"  />
                      </div>
                    </div>
                    <div class="vx-row">
                      <div class="vx-col w-full" ref="getWidth">
                        <vs-table ref="pageRankDataTable" stripe hoverFlat pagination :max-items="pagesRankDataNumberShown" v-if="brandPageRankData && brandPageRankData.length > 0" noDataText="" :data="brandPageRankData" class="w-full">
                          <template slot="thead">
                            <vs-th class="text-center">Page</vs-th>
                            <vs-th sort-key="clicks"><vs-spacer/>Clics Marques</vs-th>
                            <vs-th></vs-th>
                            <vs-th><vs-spacer/>% des clics totaux</vs-th>
                          </template>

                          <template slot-scope="{data}">
                            <vs-tr :key="index" v-for="(row, index) of data" style="width: 100%;">
                              <vs-td style="width: calc(100% - 300px);">
                                <vx-tooltip :text="textBreak(row.keys[0], 23)"><span>{{ textWrap(row.keys[0], Math.floor(($refs.getWidth.clientWidth - 300)/8)) }}</span></vx-tooltip>
                              </vs-td>
                              <vs-td style="width: 75px;" class="txt_align_right">
                                {{ row.clicks == 0 ? 0 : formatThousandNumb(row.clicks) }}
                              </vs-td>
                              <vs-td style="width: 150px;">
                                <span style="min-width: 120px;">
                                  <vs-progress
                                    class="mt-2 w-full"
                                    :percent="Number(formatValue(((row.clicks / globalSiteDataKeywords.clicks) * 100).toFixed(2)))"
                                  ></vs-progress>
                                </span>
                              </vs-td>
                              <vs-td style="width: 75px;" class="txt_align_right">
                                {{ globalSiteDataKeywords.clicks > 0 ? formatValue(((row.clicks / globalSiteDataKeywords.clicks) * 100).toFixed(2)) : "0.00" }}%
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
            </vx-card>
          </div>
          <div v-else>
            <vx-card>
              <ul>
                <li v-if="brandsLength > 0">
                  <span class="vx-row">
                    <span class="vx-col"><vs-icon icon="warning" size="medium" color="primary" /></span>
                    <span class="vx-col pt-2"> Attention vous n'avez pas défini de keywords de marque. <span v-if="$acl.check('accountmanager')" @click="showBrandsPopup" style="width: 37px;" class="hvr-underline hvr-underline-out">(Editer les marques)</span></span>
                </span></li>
              </ul>
            </vx-card>
          </div>
    </div>
</template>
<script>
import DuoBarChart from "@/components/charts/DuoBarChart.vue";
import ReportCard from "@/components/views/dashboard/statistics-cards/ReportCard.vue";
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "KeywordsFame",
	mixins: [utilsMixin],
	components: {
		DuoBarChart,
		ReportCard
	},
	props: {
		brandsLength: { // brands && (brands.length <= 0)
			type: Number,
			default: 0
		},
		pageRankDataLength: {
			type: Number,
			default: 0
		},
		societyName: {
			type: String,
			default: ""
		},
		showBrandsPopup: {
			type: Function,
			default: function(){}
		},
		brandDataTotal: {
			type: Object,
			default: null
		},
		globalSiteDataKeywords: {
			type: Object,
			default: null,
		},
		genericPosition: {
			type: Number,
			default: 0
		},
		genericCTR: {
			type: Number,
			default: 0.00
		},
		stackedColumnChartOptionBrandTraffic: {
			type: Object,
			default: null
		},
		impComparisonChartOptions: {
			type: Object,
			default: null
		},
		pageNumberOptions: {
			type: Array,
			default: () => []
		},
		brandKeywordsListing: {
			type: Array,
			default: () => []
		},
		brandPageRankData: {
			type: Array,
			default: () => []
		}
	},
	data(){
		return {
			brandKeywordsListingMaxRow: 25,
			pagesRankDataNumberShown: 25,
			pageSearchInput: ""
		};
	},
	mounted(){
		window.onresize = () => {
			return (() => {
				this.$forceUpdate();
			})();
		};
	},
	watch: {
		pageSearchInput: function(data){
			this.$refs.pageRankDataTable.searchx = data;
		}
	},
	methods: {
		openLoadingContainer(containerId){
			if(this.$refs[containerId]){
				this.$vs.loading({
					container: "#" + containerId
				});
			}
		},
		closeLoadingContainer(containerId){
			this.$vs.loading.close("#" + containerId + " > .con-vs-loading");
		}
	},
};
</script>
<style lang="scss" scoped>
.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
table{
  table-layout: fixed;
}
.txt_align_right {
  text-align: right !important;
}
.pointer {
  cursor: pointer;
}
.vx-col.w-auto.mt-4{
  min-width: 320px !important;
  width: 100% !important
}
@media screen and (min-width: 950px){
  .flex.mt-4.vx-row{
    flex-wrap: nowrap !important;
  }
}
@media screen and (max-width: 950px){
  .vx-col{
    width: 100% !important;
  }
}
</style>